import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapPopupService {
  private subject = new Subject<any>();
  constructor() { }

  closePopup() {
    this.subject.next({});
  }

  getEvent(): Observable<any> {
    return this.subject.asObservable();
  }
}
